import React from 'react';
import { useHistory } from 'react-router-dom';

import IconBtn from '../../modules/icon-btn/icon-btn';

import { ReactComponent as OperationsHistoryIcon } from './icons/operations_history_icon.svg';
import { ReactComponent as OrdersChangesIcon } from './icons/orders_changes_icon.svg';
import OrdersChangesComponent from './orders-changes';
import TransactionsHistoryComponent from './transactions-history';

import './main-screen.scss';

const IconMap = {
  operationsHistory: OperationsHistoryIcon,
  ordersChanges: OrdersChangesIcon,
} as Record<string, React.ElementType>;

interface IProps {
  title: string;
  buttonTitle: string;
  buttonAction: () => void;
  type: string;
  children: React.ReactNode;
}

const MainPageTableContainer: React.FC<IProps> = ({
  title,
  buttonTitle,
  buttonAction,
  type,
  children,
}) => {
  const Icon = IconMap[type];
  return (
    <div>
      <div className="module-wrapper">
        <div className="module-wrapper__header">
          <div className="module-wrapper__top-right">
            <IconBtn
              title={buttonTitle}
              className="btn--sm btn--outline"
              onClick={buttonAction}
            />
          </div>
          <div className="module-wrapper__icon">
            <Icon className="icon" />
          </div>
          <h2 className="module-wrapper__title">{title}</h2>
        </div>
        {children}
      </div>
    </div>
  );
};

export const TransactionsHistory = () => {
  const history = useHistory();

  return (
    <MainPageTableContainer
      title="История операций"
      buttonTitle="Вся история операций"
      buttonAction={() => history.push('/history')}
      type="operationsHistory"
    >
      <TransactionsHistoryComponent />
    </MainPageTableContainer>
  );
};

export const OrdersChanges = () => {
  const history = useHistory();

  return (
    <MainPageTableContainer
      title="Изменения в реестре"
      buttonTitle="Все изменения"
      buttonAction={() => history.push('/orders')}
      type="ordersChanges"
    >
      <OrdersChangesComponent />
    </MainPageTableContainer>
  );
};
